export default __webpack_public_path__ + "static/media/gallery-wip-handle-cover_00.e6805fdb.jpg";